import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { forwardRef, useState, useRef, useEffect } from "react";
import { Slot } from "@radix-ui/react-slot";
import { ActionIcon } from "../../ActionIcon/index.js";
import { Icons24 } from "../../Icons24Sprite/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import '../../../assets/index17.css';const actionPanel = "_actionPanel_uom3y_1";
const content = "_content_uom3y_20";
const actions = "_actions_uom3y_26";
const label = "_label_uom3y_32";
const inputWrapper = "_inputWrapper_uom3y_42";
const searchIcon = "_searchIcon_uom3y_55";
const searchInput = "_searchInput_uom3y_59";
const s = {
  actionPanel,
  content,
  actions,
  label,
  inputWrapper,
  searchIcon,
  searchInput
};
const defaultPluralizeFunction = (count) => count > 1;
const IndexPanelActionPanel = forwardRef(
  ({
    className,
    children,
    itemCount,
    rightButton,
    singularMessage = "",
    pluralMessage = "",
    foundMessage = "",
    cancelButtonElement,
    testIsPlural = defaultPluralizeFunction,
    inputElement,
    ...rest
  }, ref) => {
    const [searchMode, setSearchMode] = useState(false);
    const searchRef = useRef(null);
    const getSearchItemsMessage = () => {
      if (!Number.isFinite(itemCount)) {
        return null;
      }
      let result = `${itemCount} ${testIsPlural(itemCount) ? pluralMessage || singularMessage : singularMessage || pluralMessage}`;
      if (searchMode) {
        result = `${result} ${foundMessage}`;
      }
      return result;
    };
    useEffect(() => {
      if (searchMode && searchRef.current) {
        searchRef.current.focus();
      }
    }, [searchMode]);
    const searchItemsMessage = getSearchItemsMessage();
    return /* @__PURE__ */ jsxs("section", { ...rest, ref, className: clsx(s.actionPanel, {}, className), children: [
      /* @__PURE__ */ jsx("span", { className: s.content, children: searchMode && inputElement ? /* @__PURE__ */ jsxs("span", { className: s.inputWrapper, children: [
        /* @__PURE__ */ jsx(Icons24, { name: "Search", className: s.searchIcon }),
        /* @__PURE__ */ jsx(Slot, { className: s.searchInput, ref: searchRef, children: inputElement })
      ] }) : children }),
      /* @__PURE__ */ jsxs("div", { className: s.actions, children: [
        searchItemsMessage && /* @__PURE__ */ jsx("span", { className: s.label, children: searchItemsMessage }),
        inputElement && (!searchMode ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            ActionIcon,
            {
              actionIconType: "ghost",
              icon: /* @__PURE__ */ jsx(Icons24, { name: "Search" }),
              onClick: () => setSearchMode(!searchMode)
            }
          ),
          rightButton
        ] }) : cancelButtonElement && /* @__PURE__ */ jsx(Slot, { onClick: () => setSearchMode(!searchMode), children: cancelButtonElement }))
      ] })
    ] });
  }
);
export {
  IndexPanelActionPanel
};
